import {createAsyncThunk} from '@reduxjs/toolkit'
import {startPsd2AuthChallenge} from 'modules/psd2Auth/slice'
import Psd2 from 'services/psd2'

import {BookingStatusLink} from '@vio/core/src/api-types/bovio/response/booking_status'
import {BookingStatusThreeDomainSecureRequiredResponse} from '@vio/core/src/booking/types/BookingStatus'

import {RootState} from '../../../store'
import {require3DS} from '../slice'

export interface Handle3DSChallengeArg {
  bookingData: BookingStatusThreeDomainSecureRequiredResponse
  isChargeLaterBookingCreation: boolean
  bookingStatusLinks: BookingStatusLink[]
}

export const handle3DSChallenge = createAsyncThunk<
  void,
  Handle3DSChallengeArg,
  {state: RootState}
>('bookingCreation/handle3DSChallenge', async (arg, {dispatch}) => {
  const {bookingData, isChargeLaterBookingCreation, bookingStatusLinks} = arg
  const provider = Psd2.getProvider()

  if (provider?.isEnrolled(bookingData, isChargeLaterBookingCreation)) {
    dispatch(require3DS({bookingStatusLinks}))
    dispatch(startPsd2AuthChallenge())
  }
})
